const storageKey = 'onemember_pending_extra_profile';

/**
 * In the social registration flow the extra-profile form is collected BEFORE
 * the email/phone verification step, but the final submit (and the MoEngage
 * attribute sync) happens after verification on a different page. Stash the
 * collected values here so that sync still receives them.
 */
export const storePendingExtraProfile = (values: Record<string, unknown>) => {
  sessionStorage.setItem(storageKey, JSON.stringify(values));
};

export const consumePendingExtraProfile = (): Record<string, unknown> => {
  const raw = sessionStorage.getItem(storageKey);
  sessionStorage.removeItem(storageKey);

  if (!raw) {
    return {};
  }

  try {
    // eslint-disable-next-line no-restricted-syntax -- plain JSON round-trip of form values
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return {};
  }
};
